export default "__VITE_ASSET__fc71ce76__"